import React, { createRef } from 'react';
import { TFunction, withTranslation } from "react-i18next";
import "./TerminalReport.scss";
import Page from '../containers/page';
import FormFilter from '../containers/form-filter';
import SelectField from '../controls/fields/selectField';
import { DateHelper } from '../../helpers/DateHelper';
import { WebCache } from '../../services/WebCache';
import DateField from '../controls/fields/dateField';
import { DateObject } from 'react-multi-date-picker';
import CustomTable from '../table/CustomTable';
import { ColumnDefinition, actionColumnDefinition, dateColumnDefinition, textColumnDefinition } from '../table/ColumnDefinition';
import { Option } from '../../models/Option';
import { IInvoiceDocuement, ISearchInvoicesResponse } from '../../models/IFiscalDocument';
import { IPageRequest } from '../../models/IPageRequest';
import { ISearchInvoicesRequest } from '../../requests/IFiscalDocumentInvoicesRequest';
import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { FiscalDocumentService } from '../../services/FiscalDocumentService';
import CustomReCAPTCHA from '../CustomCaptcha';
import { ReactComponent as IconDownloadSVG } from "../../../node_modules/itd-common/assets/icons/download.svg";
import FilterFiscalDocumentAndCommerce, { MultiSelectRef } from "../FilterFiscalDocumentAndCommerce";
import { UtilService } from '../../services/UtilService';
import Pagination from '../Pagination';
import Button from '../controls/buttons/button';
import {
    ReactComponent as IconDownloadWhiteSVG
} from "../../../node_modules/itd-common/assets/icons/icon-download-white.svg";
import { IMessageContext } from '../MessagesContext';
import { withMessages } from '../contexts/MessagesContext';
import ErrorsView from '../ErrorsView';

interface IFilters {
    fiscalDocument: string[],
    dateRange: Array<DateObject>,
    documentType: string   
}
interface IProps {
    t: TFunction
    prefix:string,
    showDocumentTypes:boolean
    invoiceOrigin:number,
    documentTypeOptions: Array<Option>,
    maxDayRange:number,
    messages: IMessageContext, 
    allowDownloadAll?:boolean
}

interface IState {
    filters: IFilters,
    fiscalDocumentInvoices: Array<IInvoiceDocuement>,
    mainPage: number,
    pageRequest: IPageRequest,
    isCaptchaVerified:boolean,
    pages: number[],
    activePage:number,
    errors: string[],
}

let url= window.location.href.split("/");
const pageSize=20
const defaultPages = [1, 2, 3]
const pageQuantity = 3

class TaxDocumentationTemplate extends React.Component<IProps, IState> {
    private multiSelectRef = createRef<MultiSelectRef>();
    private columnDefinitions: Array<ColumnDefinition>;
    private divColumnSize: string = UtilService.isMobilePlatform() ? "col-md-6" : "col-md-6 col-lg-4";
    private messages: IMessageContext = this.props.messages;


    constructor(props: IProps) {
        super(props);

        this.handleFormFilterSumbit = this.handleFormFilterSumbit.bind(this);
        this.state = {
            filters: {
                fiscalDocument: [""],
                dateRange: [],
                documentType:this.props.documentTypeOptions[0]?.value+""
            },
            fiscalDocumentInvoices: [],
            mainPage: 0,
            isCaptchaVerified:sessionStorage.getItem('captchaVerified')=="true",
            pageRequest: {
                Skip: 0,
                Take: 0
            },
            pages: defaultPages,
            activePage: 1,
            errors: []
        }
        
        let url= window.location.href.split("/"); 

        let invoiceNumber= url[url.length-1] === "fiscalDocumentInvoices" ? textColumnDefinition({ key:'invoiceNumber', label:`${this.props.prefix}invoiceNumber` }): textColumnDefinition({ key: '',label: ''}) ;      
        let detailsTerminal = url[url.length-1] === "fiscalDocumentInvoices"&& WebCache.isUserARG() ? actionColumnDefinition({ key: 'downloadTerminalDetail',label:`${this.props.prefix}invoiceDetail`, action: { function: this.downloadDetail, icon: <IconDownloadSVG></IconDownloadSVG>},fixedWidth:2})
        : textColumnDefinition({ key:'',label: ''});

        this.columnDefinitions = [
            dateColumnDefinition({ key: 'date', label: `${this.props.prefix}date` }),
            textColumnDefinition({ key: 'typeDescription', label: `${this.props.prefix}documentType`}),
            invoiceNumber,
            textColumnDefinition({ key: 'documentNumber', label: `${this.props.prefix}documentNumber`}),
            actionColumnDefinition({ key: 'download',label:`${this.props.prefix}download`, action: { function: this.downloadFileAction, icon: <IconDownloadSVG></IconDownloadSVG>},fixedWidth:2}),
            detailsTerminal
        ];
    }

    setFilters(filters: IFilters) {
        this.setState({ ...this.state, filters });
    }

    clearFilter = () => {
        this.multiSelectRef.current?.clearFilters();    
        this.setState(
            prevState => ({
                ...prevState,
                filters: {
                    ...prevState.filters,
                    dateRange: [],
                    fiscalDocument: [""],
                    documentType: !this.props.showDocumentTypes ? "3" : "4"
                }
            }), () =>{
            this.handleFormFilterSumbit();
        });
    }


    buildFiscalDocumentInvoicesRequest = (all: boolean): ISearchInvoicesRequest => {
        return {
            merchantDocument: this.state.filters.fiscalDocument.includes("all") ? [] : this.state.filters.fiscalDocument.filter(x=>x.length>0),
            dateFrom: DateHelper.dateObjectToString(this.state.filters.dateRange[0]),
            dateTo: DateHelper.dateObjectToString(this.state.filters.dateRange[1]),
            documentType: this.state.filters.documentType,
            invoiceOrigin:this.props.invoiceOrigin,
            Skip: all ? 0 : (this.state.pageRequest.Skip),
            Take: all ? 0 : (this.state.pageRequest.Take)
        };
    }

    fetchFiscalDocumentInvoices = () => {

        let dateFrom= DateHelper.dateObjectToDate(this.state.filters.dateRange[0]);
        let dateTo= DateHelper.dateObjectToDate(this.state.filters.dateRange[1]);
        let diffDays =Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
        
        if(diffDays>this.props.maxDayRange){
                toast.error(`La busqueda no puede superar los ${this.props.maxDayRange} días`);
            return;
        }

        FiscalDocumentService.searchInvoices(this.buildFiscalDocumentInvoicesRequest(false)).then((response: AxiosResponse<ISearchInvoicesResponse>) => {
            if (!response || !response.data || response.data.documents.length === 0) {
                this.setState({ ...this.state, fiscalDocumentInvoices: [], errors: [] });
                return;
            }
            this.setState({ ...this.state, fiscalDocumentInvoices: response.data.documents, errors: [] });
        }).catch(error => {
            this.setState({ ...this.state, fiscalDocumentInvoices: [] });
            console.error('error:', error);
            toast.error(error.message);
        });
    }

    handleFormFilterSumbit() {
        this.setState({
            ...this.state, mainPage: 0
        }, () => {
            this.fetchFiscalDocumentInvoices();
        });
    }

    getFileExt= (type:string) => {
        if(type=="99"||type=="98"||type=="93")
            return ".txt";
        return ".pdf";
    }

    handleCaptchaVerification = (verified: boolean) => {
        this.setState({ isCaptchaVerified: verified });
    };

    downloadFileAction: (rowObject: IInvoiceDocuement) => void = (rowObject: IInvoiceDocuement) => {
        if (this.state.isCaptchaVerified) {
            FiscalDocumentService.searchInvoiceDocument({
                sapDocumentNumber: rowObject.documentNumber.toString(),
                company: rowObject.company,
                type: rowObject.type,
                format:rowObject.formats[0]
            }, `${rowObject.documentNumber.toString()}`+this.getFileExt(rowObject.type))
        .catch((error) => {
            console.error('error:', error);
            toast.error(`${this.props.t(`${this.props.prefix}downloadErrorMessage`)}`);
        });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    }

    downloadDetail: (rowObject: IInvoiceDocuement) => void = (rowObject: IInvoiceDocuement) => {
        if (this.state.isCaptchaVerified) {
                FiscalDocumentService.downloadDetails({
                    documentNumber: rowObject.documentNumber.toString(),
                }, `${rowObject.documentNumber.toString()}`+".xls")
            .catch((error) => {
                console.error('error:', error);
                toast.error(`${this.props.t(`${this.props.prefix}downloadErrorMessage`)}`);
            });
            } else {
                toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    }

    downloadZip = () =>{
        if (this.state.isCaptchaVerified) {
            this.messages.showDownloadMessage();
            FiscalDocumentService.downloadInvoicesBulk(this.buildFiscalDocumentInvoicesRequest(true))
              .then((response: AxiosResponse<ArrayBuffer>) => {
                            })
                            .catch((error) => {                                
                                this.setState({  errors: ["Error obteniendo datos del servidor"] });
                                console.log('error:', error);
                            });
        }
         else {
                    toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
                }
    }

    render() {
        const { t } = this.props;

        return (
            <Page>
                <>
                    <h2>{t("pages.fiscalDocumentInvoices.title")}</h2>
                    <div className='row'>
                            <div className='col-lg-12'>
                                <ErrorsView errors={this.state.errors} />
                            </div>
                        </div>
                    <div className='row'>
                        <div className="col-lg-12">
                            <FormFilter 
                                model={[ this.state.filters, this.setFilters.bind(this) ]} 
                                hidden={UtilService.isMobilePlatform()? true : false}
                                onSubmit={this.handleFormFilterSumbit} 
                                clear={this.clearFilter}
                            >
                            <div className="row mt-2 w-100">
                                    <FilterFiscalDocumentAndCommerce
                                        changeFilter={(fiscalDocument, merchantNumber)=>{ this.setState({
                                            ...this.state,
                                            filters: {
                                                ...this.state.filters,
                                                fiscalDocument: fiscalDocument
                                            }
                                        }); }}
                                        includeAllFiscalDocument={true}
                                        hideMerchants={true}
                                        includeWholesaler={false}
                                        ref={this.multiSelectRef}
                                    />
                                    <div className={this.divColumnSize}>
                                        <DateField
                                            attr="dateRange"
                                            label="dateRange"
                                            range
                                        ></DateField>
                                    </div>  
                                    <div className={this.divColumnSize} hidden={!this.props.showDocumentTypes}>
                                        <SelectField
                                            attr='documentType'
                                            label={`${this.props.prefix}documentType`}
                                            options={this.props.documentTypeOptions}
                                        ></SelectField>
                                    </div>
                                    </div>
                            </FormFilter>
                            {UtilService.isMobilePlatform() ?
                                (() => {
                                    const startIdx = this.state.pages.indexOf(this.state.activePage) * pageSize;
                                    const endIdx = startIdx + pageSize;
                                    const paginatedInvoices = this.state.fiscalDocumentInvoices.slice(startIdx, endIdx);
                                    return (
                                        <div>                               
                                            <div className="container">
                                                <ul className="notification">
                                                    {paginatedInvoices.map((fiscalDocumentInvoice, Tindex) => (
                                                        <li key={Tindex}>
                                                            <div className="notification-time-date mb-2 d-block d-md-none">
                                                                <span className="date">{DateHelper.formatIsoDate(fiscalDocumentInvoice.dateTime)}</span>
                                                            </div>
                                                            <div className="settlementMobile">
                                                                <div className="media mt-0">
                                                                    <div style={{ width: "60px", height: "60px", justifyContent: "center" }}>
                                                                        <p className="mb-0 fs-13 text-dark">{t(`${this.props.prefix}download`)}</p>
                                                                        <a onClick={() => { this.downloadFileAction(fiscalDocumentInvoice) }}>
                                                                            <span className="download-link ms-4 mt-5"><IconDownloadSVG /></span>
                                                                        </a>
                                                                        {url[url.length - 1] === "fiscalDocumentInvoices" && WebCache.isUserARG() && (
                                                                            <>
                                                                                <p className="mb-0 fs-13 text-dark">{t(`${this.props.prefix}invoiceDetail`)}</p>
                                                                                <a onClick={() => { this.downloadDetail(fiscalDocumentInvoice) }}>
                                                                                    <span className="download-link ms-4 mt-5"><IconDownloadSVG /></span>
                                                                                </a>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    <div className="media-body ms-3 ps-5 d-flex">
                                                                        <div>
                                                                            {url[url.length - 1] === "fiscalDocumentInvoices" && (
                                                                                <p className="mb-0 fs-13 text-muted">{t("invoiceNumber")}: {fiscalDocumentInvoice.invoiceNumber}</p>
                                                                            )}
                                                                            <p className="mb-0 fs-13 text-muted">{t(`${this.props.prefix}documentType`)}: {fiscalDocumentInvoice.typeDescription}</p>
                                                                            <p className="mb-0 fs-13 text-muted">{t(`${this.props.prefix}documentNumber`)}: {fiscalDocumentInvoice.documentNumber}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div>
                                                <Pagination
                                                    pageSize={pageSize}
                                                    pageQuantity={pageQuantity}
                                                    modifyMainPage={(value: number, newPages: Array<number>) => {
                                                        this.setState({
                                                            mainPage: this.state.mainPage + value,
                                                            pages: newPages
                                                        }, () => this.fetchFiscalDocumentInvoices());
                                                    }}
                                                    changePage={(page: number) => this.setState({ activePage: page })}
                                                    dataL={this.state.fiscalDocumentInvoices.length}
                                                    mainPage={this.state.mainPage}
                                                ></Pagination>
                                            </div>
                                        </div>
                                    );
                                })()
                            :
                            <div className='terminal-accordion-table'>
                                <div className="navbar-text ms-auto mb-3 col-12 col-md-6 fs-5 pe-0 d-flex flex-wrap justify-content-end">                        
                                        {this.state.fiscalDocumentInvoices.length > 0 && this.props.allowDownloadAll && (
                                            <div className="mb-2 flex-grow-0">
                                                <Button color="primary" className="border-0 mt-0 w-auto" onClick={() => this.downloadZip()} noBlock>
                                                    <>
                                                    <span className="ms-2 me-2">{t(`SAP_DOCUMENT_DOWNLOAD_MSG`)}</span>
                                                    <IconDownloadWhiteSVG></IconDownloadWhiteSVG>
                                                    </>
                                                </Button>
                                            </div>
                                        )}
                                      </div>
                                <CustomTable
                                    rowObjects={this.state.fiscalDocumentInvoices}
                                    columnDefinitions={this.columnDefinitions}
                                    config={{
                                        pageSize:20,
                                        paginator: {
                                            mainPage: this.state.mainPage,
                                            modifyMainPage: (value: number) => {
                                                this.setState({
                                                    mainPage: this.state.mainPage + value
                                                }, () => this.fetchFiscalDocumentInvoices())
                                            },
                                            pageRequest: this.state.pageRequest
                                        }
                                    }}
                                ></CustomTable>
                            </div>}
                            <div className='row mt-4'>
                                <div className='col-md-6' >
                                </div>
                                <div className="col-md-6 d-flex justify-content-center align-items-start">
                                    <CustomReCAPTCHA useCache={true} onVerify={this.handleCaptchaVerification}></CustomReCAPTCHA>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
            </Page>
        )
    };
}

export default withMessages(withTranslation()(TaxDocumentationTemplate));
